<script lang="ts" setup>
import { GpCard } from '@gportal/uikit';
import { BillingPeriod } from 'gpcore-grpc/gpcore/api/cloud/v1/billing_pb';
import { type Flavour, FlavourAvailability } from 'gpcore-grpc/gpcore/api/cloud/v1/flavour_pb';
import SpecSheet from 'gpcore-uikit/components/new/specs/SpecSheet.vue';
import SpecSheetItem from 'gpcore-uikit/components/new/specs/SpecSheetItem.vue';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    flavour: Flavour;
    isSelected?: boolean;
    currentBillingPeriod: BillingPeriod;
    isAllFlavoursAvailable?: boolean;
  }>(),
  {
    isSelected: false,
    billingPeriodOptions: () => [],
    isAllFlavoursAvailable: false,
  },
);

const emit = defineEmits<{
  (e: 'flavourSelected');
  (e: 'billingPeriodSelected', value: BillingPeriod);
}>();

const isFlavourOutOfStock = computed(
  () => props.flavour.availability === FlavourAvailability.OUT_OF_STOCK,
);

const isFlavourRegularyAvailable = computed(
  () =>
    // a flavour is regularly available if it is not out of stock, low availability or unspecified
    props.flavour.availability !== FlavourAvailability.LOW &&
    props.flavour.availability !== FlavourAvailability.OUT_OF_STOCK &&
    props.flavour.availability !== FlavourAvailability.UNSPECIFIED,
);

const handleClick = () => {
  emit('flavourSelected');
};
</script>

<template>
  <GpCard
    :active="isSelected"
    :aria-selected="isSelected"
    :body-class="!isAllFlavoursAvailable && isFlavourRegularyAvailable ? 'tw-pt-5' : ''"
    :class="{
      'tw-pointer-events-none tw-border-transparent tw-opacity-70': isFlavourOutOfStock,
      'tw-cursor-pointer': !isFlavourOutOfStock && !isSelected,
    }"
    :enlarge-on-hover="false"
    @click="handleClick"
  >
    <span
      v-if="isFlavourOutOfStock"
      class="tw-absolute tw-inset-x-0 tw-top-0 tw-h-5 tw-w-auto tw-rounded-t tw-bg-gp-fire tw-text-center tw-text-xs tw-font-bold tw-uppercase tw-text-white"
    >
      Sold out
    </span>
    <span
      v-if="flavour.availability === FlavourAvailability.LOW"
      class="tw-absolute tw-inset-x-0 tw-top-0 tw-h-5 tw-w-auto tw-rounded-t tw-bg-gp-orange tw-text-center tw-text-xs tw-font-bold tw-uppercase tw-text-black"
    >
      Low Availability
    </span>

    <div :class="isAllFlavoursAvailable ? 'tw-pt-4' : 'tw-pt-8'" class="tw-px-4 tw-pb-6">
      <p class="tw-mb-2 tw-text-xl tw-font-bold">
        {{ flavour.name }}
      </p>

      <!--<Price
        v-if="flavour.pricePerHour && currentBillingPeriod === BillingPeriod.HOURLY"
        class="tw-mb-2"
        :price="flavour.pricePerHour"
        :billing-period="BillingPeriod.HOURLY"
      />
      <Price
        v-if="flavour.pricePerMonth && currentBillingPeriod === BillingPeriod.MONTHLY"
        class="tw-mb-2"
        :price="flavour.pricePerMonth"
        :billing-period="BillingPeriod.MONTHLY"
      />
      <hr class="tw-my-4" />-->

      <SpecSheet class="tw-mt-2" dense vertical>
        <SpecSheetItem :value="flavour.cpu" dense label="CPU" />
        <SpecSheetItem :value="flavour.memory" dense label="Memory" />
        <SpecSheetItem :value="flavour.disk" dense label="Disk" />
        <SpecSheetItem :value="flavour.network" dense label="Network" />
        <SpecSheetItem :value="`${flavour.traffic}GB`" dense label="Monthly traffic" />
      </SpecSheet>
    </div>
  </GpCard>
</template>
